import { Action } from "@ngrx/store";
import { ScheduleLayout } from "@app/core/schedule/schedule-layout";

export const SCHEDULE_KEY = "SCHEDULE";

export enum ScheduleActionTypes {
  SAVE = "[Schedule] Save"
}

export class ActionScheduleSave implements Action {
  readonly type = ScheduleActionTypes.SAVE;

  constructor(
    readonly payload: {
      startHour: number;
      numberOfHours: number;
      today: boolean;
      selectedDate: Date;
      layout: ScheduleLayout;
      showMap: boolean;
    }
  ) {}
}

export type ScheduleActions = ActionScheduleSave;

export const initialScheduleState: ScheduleState = {
  startHour: 0,
  numberOfHours: 24,
  today: true,
  selectedDate: new Date(),
  layout: new ScheduleLayout(),
  showMap: false
};

export const selectorSchedule = (state) => state.schedule;

export function scheduleReducer(
  state: ScheduleState = initialScheduleState,
  action: ScheduleActions
): ScheduleState {
  // console.log("schedule reducer");
  switch (action.type) {
    case ScheduleActionTypes.SAVE:
      return {
        ...state,
        startHour: action.payload.startHour,
        numberOfHours: action.payload.numberOfHours,
        today: action.payload.today,
        selectedDate: action.payload.selectedDate,
        layout: action.payload.layout,
        showMap: action.payload.showMap
      };

    default:
      return state;
  }
}

export interface ScheduleState {
  startHour: number;
  numberOfHours: number;
  today: boolean;
  showMap: boolean;
  selectedDate: Date;
  layout: ScheduleLayout;
}
